/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Orders_Booking_Manual_Status_WarningInputs */

const en_orders_booking_manual_status_warning = /** @type {(inputs: Orders_Booking_Manual_Status_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} booked order(s) need manual status update.`)
};

const es_orders_booking_manual_status_warning = /** @type {(inputs: Orders_Booking_Manual_Status_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} pedido(s) reservados necesitan actualizacion manual de estado.`)
};

/**
* | output |
* | --- |
* | "{count} booked order(s) need manual status update." |
*
* @param {Orders_Booking_Manual_Status_WarningInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_booking_manual_status_warning = /** @type {((inputs: Orders_Booking_Manual_Status_WarningInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Booking_Manual_Status_WarningInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_booking_manual_status_warning(inputs)
	return es_orders_booking_manual_status_warning(inputs)
});